import React, { createContext, useContext, useEffect, useState } from "react";
import { t as translate } from "@/lib/i18n";

const KEY = "tc-lang";
const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const raw = localStorage.getItem(KEY);
    return raw === "tl" ? "tl" : "en"; // English is default
  });

  useEffect(() => {
    localStorage.setItem(KEY, lang);
    document.documentElement.lang = lang === "tl" ? "tl-PH" : "en-NZ";
  }, [lang]);

  const t = (key, fallback) => translate(key, lang, fallback);
  const toggle = () => setLang((s) => (s === "en" ? "tl" : "en"));

  return (
    <LangContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useLang must be inside LangProvider");
  return ctx;
}
